import React, { useContext, useEffect, useState } from 'react';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsRtMatchContext } from '../../cnr/contexts/SportsRtMatchContext';
import { SportsEditMatchContext } from '../../cnr/contexts/SportsEditMatchContext';
import { _matchResultTypes } from '../../cnr/reducers/SportsMatchReducer';
import { useMatchUpdate } from 'projectSpecific/sports/useHelpers/useMatchUpdate';
import MatchScoreboard from './MatchScoreboard';

export const _keypadTypes = {
  normal: 'normal',
  realtime: 'realtime',
  mini: 'mini',
}

const keyPadIcons = {
  down: 'arrow down',
  up: 'arrow up',
}

const WAIT_INTERVAL = 1000

/** Keypad for realtime scoring
 * @description Called only from MatchSetScoring
 */
const MatchScoreKeypad = (props) => {

  const { keypadType, handleClose } = props

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state, sportsMatch_handlers } = sportsMatchContext ?? {}
  const { match_true } = sportsMatch_state ?? {}

  // sportsMatchContext
  const sportsEditMatchContext = useContext(SportsEditMatchContext)
  const { sportsEditMatch_state, sportsEditMatch_handlers } = sportsEditMatchContext ?? {}
  const { match_edit, sportPermissions } = sportsEditMatch_state ?? {}

  // sportsMatchContext
  const sportsRtMatchContext = useContext(SportsRtMatchContext)
  const { sportsRtMatch_state, sportsRtMatch_handlers } = sportsRtMatchContext ?? {}
  const { match_rt } = sportsRtMatch_state ?? {}

  const [currentMatch, setCurrentMatch] = useState()
  const [currentMatchType, setCurrentMatchType] = useState()
  const [directScoresOn, setDirectScoresOn] = useState()
  const [currentSetNumber, setCurrentSetNumber] = useState()
  const [showUpdate, setShowUpdate] = useState()
  const [showRemove, setShowRemove] = useState()
  const [restrictAccess, setRestrictAccess] = useState()

  const { handle_updateMatchScore } = useMatchUpdate()

  const { home, away, _status } = currentMatch ?? {}
  const { setsToWin } = _status ?? {}
  const _setsToWin = setsToWin || 5

  const _allowUpdate = sportPermissions && sportPermissions.any && sportPermissions.matches

  const [matchResults, setMatchResults] = useState()
  const { scores, setNumber, setsCompleted, match_complete_possible, setsDisplayed } = matchResults ?? {}
  const _setsCompleted = setsCompleted || 0
  const _setsDisplayed = setsDisplayed || _setsToWin

  useEffect(() => {
    const _match = match_rt || match_edit || match_true
    const results = _match?._results
    setCurrentMatch(_match)
    setMatchResults(results)
    if (results && results.setNumber) {
      setCurrentSetNumber(results.setNumber)
    }
    let _currentMatchType;
    if (match_true) { _currentMatchType = 'match_true' }
    if (match_edit) { _currentMatchType = 'match_edit' }
    if (match_rt) { _currentMatchType = 'match_rt' }
    setCurrentMatchType(_currentMatchType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match_true, match_rt, match_edit]);

  useEffect(() => {
    if (restrictAccess) {
      const timer = setTimeout(() => setRestrictAccess(false), WAIT_INTERVAL);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restrictAccess]);

  // const handleStopProp = (e) => {
  //   e.stopPropagation()
  // }

  // const allowItemChange = (e, rtType, setNumber) => {
  //   e.stopPropagation()
  //   setDirectScoresOn(rtType)
  //   if (setNumber) { setCurrentSetNumber(setNumber) }
  // }

  // const handleShowUpdateScore = (e) => {
  //   e.stopPropagation()
  //   setShowUpdate(!showUpdate)
  // }

  // const handleRtUpdateScore = (e) => {
  //   e.stopPropagation()
  //   handle_updateMatchScore({ match_rt, currentMatch, matchResultType: _matchResultTypes.normal })
  //   // sportsMatch_handlers.handleUpdate_matchResults(currentMatch, _matchResultTypes.normal)
  // }

  // const handleShowRemoveScore = (e) => {
  //   e.stopPropagation()
  //   setShowRemove(!showRemove)
  // }

  // const handleRtRemoveScore = (e) => {
  //   e.stopPropagation()
  //   sportsRtMatch_handlers.handleRtDelete_scores()
  // }

  // updates the realtime match
  // const handleScoreUpdate = (e, rtType, add) => {
  //   e.stopPropagation()
  //   setRestrictAccess(true)
  //   !restrictAccess && sportsRtMatch_handlers.handleRtUpdate_score(currentMatch, rtType, add, currentSetNumber)
  // }

  // const handleClear_scores = (e, sn) => {
  //   const _matchToUpdate = { ...currentMatch }
  //   let { results } = _matchToUpdate

  //   if (!results) { results = {} }

  //   if (sn) {
  //     if (results?.scores?.[sn]) {
  //       delete results.scores[sn]
  //     }
  //   } else {
  //     results.scores = {}
  //   }

  //   switch (keypadType) {
  //     case _keypadTypes.normal:
  //       sportsEditMatch_handlers.handleAmmend_editMatch(_matchToUpdate)
  //       break;

  //     case _keypadTypes.mini:
  //     case _keypadTypes.realtime:
  //       sportsRtMatch_handlers.handleRtChange_setScores(_matchToUpdate)
  //       break;
  //     default:
  //     // nothing
  //   }
  // }

  const handleDirectScoresOn = (e) => {
    setDirectScoresOn(!directScoresOn)
  }

  const handleUpdate_scores = (scores) => {

    const _matchToUpdate = { ...currentMatch }
    let { results, _results } = _matchToUpdate

    if (!results) { results = {} }

    let { setNumber: sn } = _results
    if (currentSetNumber) { sn = currentSetNumber }

    if (!results.scores) { results.scores = {} }

    results.scores = scores

    _matchToUpdate.results = results

    switch (keypadType) {
      case _keypadTypes.normal:
        sportsEditMatch_handlers.handleAmmend_editMatch(_matchToUpdate)
        break;

      case _keypadTypes.mini:
      case _keypadTypes.realtime:
        sportsRtMatch_handlers.handleRtChange_setScores(_matchToUpdate)
        break;
      default:
      // nothing
    }

    handleDirectScoresOn()
  }

  return <MatchScoreboard
    currentMatch={currentMatch}
    currentSetNumber={currentSetNumber}
    handleUpdate_scores={handleUpdate_scores}
    onClose={handleDirectScoresOn}
  />

}

export default MatchScoreKeypad